import type RootStore from "stores/RootStore";
import { RouteType } from "types/RouteType";
import { throwIfFailed } from "shared/dialogSubmit";
import PartnersStore from "./PartnersStore";

const partnersRoute: RouteType[] = [
  {
    name: "Partners",
    path: "/meeting-partners",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Partners",
        enableRefreshButton: true,
        component: () => import("./Partners.Header"),
      },
      body: {
        component: () => import("./Partners.Body"),
        grayBackground: true,
      },
    },
    group: "Meeting Intelligence",
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      (rootStore.partnersAdminStore as PartnersStore)?.load();
    },
    dialogs: [
      {
        name: "PartnerFormDialog",
        title: "Partner",
        submitButtonText: "Save partner",
        component: () => import("./dialogs/PartnerForm.Body"),
        cancelButton: true,
        height: 520,
        onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
          // A refused save throws, so the dialog stays open with the reason in
          // its footer (shared/dialogSubmit).
          const store = rootStore.partnersAdminStore as PartnersStore;
          throwIfFailed(await store.savePartner(), store.formError, "The partner could not be saved.");
        },
        onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) =>
          (rootStore.partnersAdminStore as PartnersStore).isFormValid,
      },
    ],
  },
];

export default partnersRoute;
